
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const MessageOutboxStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  DEAD: 'DEAD'
} as const

export type MessageOutboxStatus = (typeof MessageOutboxStatus)[keyof typeof MessageOutboxStatus]


export const MessageRoutingType = {
  INDIVIDUAL: 'INDIVIDUAL',
  GROUP: 'GROUP'
} as const

export type MessageRoutingType = (typeof MessageRoutingType)[keyof typeof MessageRoutingType]


export const MessageInboxStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type MessageInboxStatus = (typeof MessageInboxStatus)[keyof typeof MessageInboxStatus]


export const EventStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus]


export const CRUDEvent = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  READ: 'READ'
} as const

export type CRUDEvent = (typeof CRUDEvent)[keyof typeof CRUDEvent]


export const BlockType = {
  METRIC: 'METRIC',
  LIST: 'LIST',
  FORM: 'FORM',
  LINK: 'LINK'
} as const

export type BlockType = (typeof BlockType)[keyof typeof BlockType]


export const PageType = {
  LIST: 'LIST',
  INSTANCE: 'INSTANCE'
} as const

export type PageType = (typeof PageType)[keyof typeof PageType]


export const PageElementType = {
  CARD: 'CARD',
  SPREADSHEET: 'SPREADSHEET',
  KANBAN: 'KANBAN'
} as const

export type PageElementType = (typeof PageElementType)[keyof typeof PageElementType]


export const FieldRequirement = {
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  ON_CREATE: 'ON_CREATE'
} as const

export type FieldRequirement = (typeof FieldRequirement)[keyof typeof FieldRequirement]


export const RelationshipCardinality = {
  ONE_TO_ONE: 'ONE_TO_ONE',
  ONE_TO_MANY: 'ONE_TO_MANY',
  MANY_TO_ONE: 'MANY_TO_ONE',
  MANY_TO_MANY: 'MANY_TO_MANY',
  EXTERNAL: 'EXTERNAL'
} as const

export type RelationshipCardinality = (typeof RelationshipCardinality)[keyof typeof RelationshipCardinality]


export const OnDeleteBehavior = {
  NONE: 'NONE',
  CASCADE: 'CASCADE',
  RESTRICT: 'RESTRICT',
  SET_NULL: 'SET_NULL'
} as const

export type OnDeleteBehavior = (typeof OnDeleteBehavior)[keyof typeof OnDeleteBehavior]


export const AppVersionBuildStatus = {
  PENDING: 'PENDING',
  BUILDING: 'BUILDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
} as const

export type AppVersionBuildStatus = (typeof AppVersionBuildStatus)[keyof typeof AppVersionBuildStatus]


export const DeploymentStatus = {
  PENDING: 'PENDING',
  BUILDING: 'BUILDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  QUEUED: 'QUEUED'
} as const

export type DeploymentStatus = (typeof DeploymentStatus)[keyof typeof DeploymentStatus]


export const PendingDeploymentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED'
} as const

export type PendingDeploymentStatus = (typeof PendingDeploymentStatus)[keyof typeof PendingDeploymentStatus]


export const ExecutableStatus = {
  PENDING: 'PENDING',
  BUILDING: 'BUILDING',
  STARTING: 'STARTING',
  RUNNING: 'RUNNING',
  COLD: 'COLD',
  STOPPING: 'STOPPING',
  STOPPED: 'STOPPED',
  FAILED: 'FAILED',
  ARCHIVED: 'ARCHIVED'
} as const

export type ExecutableStatus = (typeof ExecutableStatus)[keyof typeof ExecutableStatus]


export const ProvisionStatus = {
  PENDING: 'PENDING',
  STARTING: 'STARTING',
  HEALTH_CHECK: 'HEALTH_CHECK',
  ASSIGNING: 'ASSIGNING',
  STOPPING_LEGACY: 'STOPPING_LEGACY',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SYNCING_TOOLS: 'SYNCING_TOOLS',
  SYNCING_RESOURCES: 'SYNCING_RESOURCES',
  PROVISION_HANDLER: 'PROVISION_HANDLER',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  CANCELLED: 'CANCELLED'
} as const

export type ProvisionStatus = (typeof ProvisionStatus)[keyof typeof ProvisionStatus]


export const AppCategory = {
  COMMUNICATION: 'COMMUNICATION',
  CRM: 'CRM',
  ANALYTICS: 'ANALYTICS',
  MARKETING: 'MARKETING',
  SUPPORT: 'SUPPORT',
  PRODUCTIVITY: 'PRODUCTIVITY',
  OTHER: 'OTHER'
} as const

export type AppCategory = (typeof AppCategory)[keyof typeof AppCategory]


export const AppVariableVisibility = {
  ENCRYPTED: 'ENCRYPTED',
  VISIBLE: 'VISIBLE'
} as const

export type AppVariableVisibility = (typeof AppVariableVisibility)[keyof typeof AppVariableVisibility]


export const EnvVariableOwnerLevel = {
  WORKPLACE: 'WORKPLACE',
  APP_VERSION: 'APP_VERSION',
  APP_INSTALL: 'APP_INSTALL',
  COMMUNICATION_CHANNEL: 'COMMUNICATION_CHANNEL',
  WORKFLOW: 'WORKFLOW',
  LLM_PROVIDER: 'LLM_PROVIDER',
  SYSTEM: 'SYSTEM'
} as const

export type EnvVariableOwnerLevel = (typeof EnvVariableOwnerLevel)[keyof typeof EnvVariableOwnerLevel]


export const AppResourceType = {
  MODEL: 'MODEL',
  FIELD: 'FIELD',
  CHANNEL: 'CHANNEL',
  WORKFLOW: 'WORKFLOW',
  ACTION: 'ACTION',
  TOOL: 'TOOL',
  RELATIONSHIP: 'RELATIONSHIP',
  PAGE: 'PAGE',
  CHANNEL_FIELD: 'CHANNEL_FIELD',
  CHANNEL_MODEL_LINK: 'CHANNEL_MODEL_LINK'
} as const

export type AppResourceType = (typeof AppResourceType)[keyof typeof AppResourceType]


export const AppResourceScope = {
  INTERNAL: 'INTERNAL',
  SHARED: 'SHARED'
} as const

export type AppResourceScope = (typeof AppResourceScope)[keyof typeof AppResourceScope]


export const AppResourceStatus = {
  READY: 'READY',
  DEPRECATED: 'DEPRECATED',
  INCOMPLETE: 'INCOMPLETE',
  ORPHANED: 'ORPHANED',
  PENDING: 'PENDING',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  BLOCKED: 'BLOCKED'
} as const

export type AppResourceStatus = (typeof AppResourceStatus)[keyof typeof AppResourceStatus]


export const AppInstallationStatus = {
  INSTALLING: 'INSTALLING',
  INSTALLED: 'INSTALLED',
  UNINSTALLING: 'UNINSTALLING'
} as const

export type AppInstallationStatus = (typeof AppInstallationStatus)[keyof typeof AppInstallationStatus]


export const AppInstallationAuthStatus = {
  PENDING: 'PENDING',
  AUTHENTICATED: 'AUTHENTICATED',
  INVALID: 'INVALID'
} as const

export type AppInstallationAuthStatus = (typeof AppInstallationAuthStatus)[keyof typeof AppInstallationAuthStatus]


export const AppInstallSetupStepKind = {
  APP: 'APP',
  CRM: 'CRM',
  REALTIME: 'REALTIME',
  ENV: 'ENV'
} as const

export type AppInstallSetupStepKind = (typeof AppInstallSetupStepKind)[keyof typeof AppInstallSetupStepKind]


export const AppInstallSetupStepStatus = {
  PENDING: 'PENDING',
  READY: 'READY',
  SKIPPED: 'SKIPPED',
  INVALIDATED: 'INVALIDATED',
  BLOCKED: 'BLOCKED'
} as const

export type AppInstallSetupStepStatus = (typeof AppInstallSetupStepStatus)[keyof typeof AppInstallSetupStepStatus]


export const BatchJobKind = {
  ACTION_BATCH: 'ACTION_BATCH',
  BULK_TEMPLATED_MESSAGE: 'BULK_TEMPLATED_MESSAGE',
  APP_OPERATION: 'APP_OPERATION'
} as const

export type BatchJobKind = (typeof BatchJobKind)[keyof typeof BatchJobKind]


export const BatchJobStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type BatchJobStatus = (typeof BatchJobStatus)[keyof typeof BatchJobStatus]


export const SubscriptionOptIn = {
  OPT_IN: 'OPT_IN',
  OPT_OUT: 'OPT_OUT',
  TRANSACTIONAL_ONLY: 'TRANSACTIONAL_ONLY'
} as const

export type SubscriptionOptIn = (typeof SubscriptionOptIn)[keyof typeof SubscriptionOptIn]


export const AgentRunTrigger = {
  MESSAGE: 'MESSAGE',
  SCHEDULED: 'SCHEDULED',
  MANUAL: 'MANUAL',
  WEBHOOK: 'WEBHOOK',
  THREAD_LINK: 'THREAD_LINK',
  TIMEOUT: 'TIMEOUT'
} as const

export type AgentRunTrigger = (typeof AgentRunTrigger)[keyof typeof AgentRunTrigger]


export const ToolKind = {
  MCP: 'MCP',
  INTERNAL: 'INTERNAL',
  SYSTEM: 'SYSTEM',
  AGENT: 'AGENT'
} as const

export type ToolKind = (typeof ToolKind)[keyof typeof ToolKind]


export const ToolExecutionMode = {
  ALLOW_ALL: 'ALLOW_ALL',
  REQUIRE_APPROVAL: 'REQUIRE_APPROVAL'
} as const

export type ToolExecutionMode = (typeof ToolExecutionMode)[keyof typeof ToolExecutionMode]


export const AgentKind = {
  SYSTEM: 'SYSTEM',
  APP: 'APP',
  WORKSPACE: 'WORKSPACE',
  MODEL: 'MODEL'
} as const

export type AgentKind = (typeof AgentKind)[keyof typeof AgentKind]


export const AgentRunStatus = {
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  INTERRUPTED: 'INTERRUPTED',
  RECOVERING: 'RECOVERING',
  WAITING_WORKER: 'WAITING_WORKER',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
  COMPACTING: 'COMPACTING'
} as const

export type AgentRunStatus = (typeof AgentRunStatus)[keyof typeof AgentRunStatus]


export const ToolCallStatus = {
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
} as const

export type ToolCallStatus = (typeof ToolCallStatus)[keyof typeof ToolCallStatus]


export const ToolInterruptBehavior = {
  DROP: 'DROP',
  FINISH: 'FINISH',
  BLOCK: 'BLOCK'
} as const

export type ToolInterruptBehavior = (typeof ToolInterruptBehavior)[keyof typeof ToolInterruptBehavior]


export const AgentRunRole = {
  STANDALONE: 'STANDALONE',
  COORDINATOR: 'COORDINATOR',
  WORKER: 'WORKER',
  FORK: 'FORK'
} as const

export type AgentRunRole = (typeof AgentRunRole)[keyof typeof AgentRunRole]


export const RecoveryStrategy = {
  OUTPUT_TOKEN_ESCALATION: 'OUTPUT_TOKEN_ESCALATION',
  CONTEXT_COMPACTION: 'CONTEXT_COMPACTION',
  MODEL_DOWNGRADE: 'MODEL_DOWNGRADE',
  MULTI_TURN_SPLIT: 'MULTI_TURN_SPLIT'
} as const

export type RecoveryStrategy = (typeof RecoveryStrategy)[keyof typeof RecoveryStrategy]


export const ToolStreamingPhase = {
  NONE: 'NONE',
  QUEUED: 'QUEUED',
  EXECUTING: 'EXECUTING',
  STREAMING_RESULT: 'STREAMING_RESULT',
  FINALIZING: 'FINALIZING'
} as const

export type ToolStreamingPhase = (typeof ToolStreamingPhase)[keyof typeof ToolStreamingPhase]


export const AgentMemoryScope = {
  USER: 'USER',
  PROJECT: 'PROJECT',
  LOCAL: 'LOCAL'
} as const

export type AgentMemoryScope = (typeof AgentMemoryScope)[keyof typeof AgentMemoryScope]


export const AgentMemorySource = {
  AGENT: 'AGENT',
  MANUAL: 'MANUAL',
  IMPORT: 'IMPORT',
  SYSTEM: 'SYSTEM'
} as const

export type AgentMemorySource = (typeof AgentMemorySource)[keyof typeof AgentMemorySource]


export const AgentNotificationKind = {
  TASK_ASSIGNMENT: 'TASK_ASSIGNMENT',
  STATUS_UPDATE: 'STATUS_UPDATE',
  RESULT: 'RESULT',
  REQUEST: 'REQUEST',
  RESPONSE: 'RESPONSE',
  INTERRUPT: 'INTERRUPT'
} as const

export type AgentNotificationKind = (typeof AgentNotificationKind)[keyof typeof AgentNotificationKind]


export const AgentNotificationStatus = {
  PENDING: 'PENDING',
  READ: 'READ',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED'
} as const

export type AgentNotificationStatus = (typeof AgentNotificationStatus)[keyof typeof AgentNotificationStatus]


export const CompactionTrigger = {
  TOKEN_LIMIT: 'TOKEN_LIMIT',
  REACTIVE: 'REACTIVE',
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED'
} as const

export type CompactionTrigger = (typeof CompactionTrigger)[keyof typeof CompactionTrigger]


export const CompactionStrategy = {
  SUMMARIZE_ALL: 'SUMMARIZE_ALL',
  SUMMARIZE_OLDEST: 'SUMMARIZE_OLDEST',
  TRUNCATE: 'TRUNCATE',
  HIERARCHICAL: 'HIERARCHICAL'
} as const

export type CompactionStrategy = (typeof CompactionStrategy)[keyof typeof CompactionStrategy]


export const RequestMethod = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT'
} as const

export type RequestMethod = (typeof RequestMethod)[keyof typeof RequestMethod]


export const WebhookLevel = {
  PROVISION: 'PROVISION',
  INSTALL: 'INSTALL',
  ACTION: 'ACTION'
} as const

export type WebhookLevel = (typeof WebhookLevel)[keyof typeof WebhookLevel]


export const WebhookType = {
  WEBHOOK: 'WEBHOOK',
  CALLBACK: 'CALLBACK'
} as const

export type WebhookType = (typeof WebhookType)[keyof typeof WebhookType]


export const AgentConversationRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  TOOL: 'TOOL'
} as const

export type AgentConversationRole = (typeof AgentConversationRole)[keyof typeof AgentConversationRole]


export const AgentContextType = {
  INSTANCE: 'INSTANCE',
  MODEL: 'MODEL',
  APP: 'APP',
  PAGE: 'PAGE',
  WORKFLOW: 'WORKFLOW',
  FILE: 'FILE'
} as const

export type AgentContextType = (typeof AgentContextType)[keyof typeof AgentContextType]


export const ContactMethod = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
} as const

export type ContactMethod = (typeof ContactMethod)[keyof typeof ContactMethod]


export const ParseToOption = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  JSON: 'JSON'
} as const

export type ParseToOption = (typeof ParseToOption)[keyof typeof ParseToOption]


export const ModelRelationship = {
  CORE: 'CORE',
  ONE_TO_ONE: 'ONE_TO_ONE',
  ONE_TO_MANY: 'ONE_TO_MANY'
} as const

export type ModelRelationship = (typeof ModelRelationship)[keyof typeof ModelRelationship]


export const OrderPaymentStatus = {
  OUTSTANDING: 'OUTSTANDING',
  DUE: 'DUE',
  UP_TO_DATE: 'UP_TO_DATE',
  BALANCE_SETTLED: 'BALANCE_SETTLED'
} as const

export type OrderPaymentStatus = (typeof OrderPaymentStatus)[keyof typeof OrderPaymentStatus]


export const OrderRefundStatus = {
  NONE: 'NONE',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED'
} as const

export type OrderRefundStatus = (typeof OrderRefundStatus)[keyof typeof OrderRefundStatus]


export const DayOfWeek = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
} as const

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek]


export const NotificationDeliveryMethod = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH: 'PUSH'
} as const

export type NotificationDeliveryMethod = (typeof NotificationDeliveryMethod)[keyof typeof NotificationDeliveryMethod]


export const TransactionType = {
  CHARGE: 'CHARGE',
  REFUND: 'REFUND'
} as const

export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType]


export const SupportedLanguage = {
  en: 'en'
} as const

export type SupportedLanguage = (typeof SupportedLanguage)[keyof typeof SupportedLanguage]


export const PriceRule = {
  PER_MINUTE: 'PER_MINUTE',
  PER_5_MINUTES: 'PER_5_MINUTES',
  PER_10_MINUTES: 'PER_10_MINUTES',
  PER_15_MINUTES: 'PER_15_MINUTES',
  PER_30_MINUTES: 'PER_30_MINUTES',
  PER_HOUR: 'PER_HOUR',
  PER_SESSION: 'PER_SESSION'
} as const

export type PriceRule = (typeof PriceRule)[keyof typeof PriceRule]


export const StripeInvoiceStatus = {
  DRAFT: 'DRAFT',
  VOID: 'VOID',
  OPEN: 'OPEN',
  PAID: 'PAID',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE'
} as const

export type StripeInvoiceStatus = (typeof StripeInvoiceStatus)[keyof typeof StripeInvoiceStatus]


export const StripeChargeStatus = {
  SUCCEEDED: 'SUCCEEDED',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
} as const

export type StripeChargeStatus = (typeof StripeChargeStatus)[keyof typeof StripeChargeStatus]


export const StripeRefundStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  REQUIRES_ACTION: 'REQUIRES_ACTION',
  CANCELED: 'CANCELED',
  PENDING: 'PENDING'
} as const

export type StripeRefundStatus = (typeof StripeRefundStatus)[keyof typeof StripeRefundStatus]


export const StripeTerminalReaderStatus = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
} as const

export type StripeTerminalReaderStatus = (typeof StripeTerminalReaderStatus)[keyof typeof StripeTerminalReaderStatus]


export const StripeTerminalReaderActionStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  IN_TRANSIT: 'IN_TRANSIT'
} as const

export type StripeTerminalReaderActionStatus = (typeof StripeTerminalReaderActionStatus)[keyof typeof StripeTerminalReaderActionStatus]


export const CommunicationChannelStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type CommunicationChannelStatus = (typeof CommunicationChannelStatus)[keyof typeof CommunicationChannelStatus]


export const ResourceStatus = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
} as const

export type ResourceStatus = (typeof ResourceStatus)[keyof typeof ResourceStatus]


export const RoundingMethod = {
  ROUND_DOWN: 'ROUND_DOWN',
  ROUND_UP: 'ROUND_UP'
} as const

export type RoundingMethod = (typeof RoundingMethod)[keyof typeof RoundingMethod]


export const FrequencyInterval = {
  ONE_TIME: 'ONE_TIME',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  FORTNIGHTLY: 'FORTNIGHTLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY'
} as const

export type FrequencyInterval = (typeof FrequencyInterval)[keyof typeof FrequencyInterval]


export const TransactionKind = {
  SALE: 'SALE',
  REFUND: 'REFUND'
} as const

export type TransactionKind = (typeof TransactionKind)[keyof typeof TransactionKind]


export const SessionCreationMode = {
  UNRESTRICTED: 'UNRESTRICTED',
  JOIN_ONLY: 'JOIN_ONLY',
  CREATE_ONLY: 'CREATE_ONLY'
} as const

export type SessionCreationMode = (typeof SessionCreationMode)[keyof typeof SessionCreationMode]


export const Resource = {
  CUSTOMER: 'CUSTOMER',
  DEPENDANT: 'DEPENDANT',
  SERVICE: 'SERVICE',
  SPACE: 'SPACE',
  LOCATION: 'LOCATION',
  WORKPLACE: 'WORKPLACE',
  PRODUCT: 'PRODUCT',
  PRODUCT_VARIANT: 'PRODUCT_VARIANT',
  ORDER: 'ORDER',
  CAMPAIGN: 'CAMPAIGN',
  CHAT_MESSAGE: 'CHAT_MESSAGE'
} as const

export type Resource = (typeof Resource)[keyof typeof Resource]


export const StripePayoutStatus = {
  PAID: 'PAID',
  PENDING: 'PENDING',
  IN_TRANSIT: 'IN_TRANSIT',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED'
} as const

export type StripePayoutStatus = (typeof StripePayoutStatus)[keyof typeof StripePayoutStatus]


export const TransactionChannel = {
  CHECKOUT: 'CHECKOUT',
  TERMINAL_READER: 'TERMINAL_READER',
  MANUAL: 'MANUAL',
  INVOICE_LINK: 'INVOICE_LINK'
} as const

export type TransactionChannel = (typeof TransactionChannel)[keyof typeof TransactionChannel]


export const WorkflowStepType = {
  TASK: 'TASK',
  WORKFLOW: 'WORKFLOW'
} as const

export type WorkflowStepType = (typeof WorkflowStepType)[keyof typeof WorkflowStepType]


export const PaymentMethod = {
  CASH: 'CASH',
  CREDIT_CARD: 'CREDIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
  TEST_ORDER: 'TEST_ORDER',
  CHEQUE: 'CHEQUE',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  TERMINAL: 'TERMINAL',
  PAYPAL: 'PAYPAL',
  ZIP: 'ZIP',
  AFTERPAY: 'AFTERPAY',
  OTHER: 'OTHER'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]


export const WorkflowStepStatus = {
  QUEUED: 'QUEUED',
  PAUSED: 'PAUSED',
  RUNNING: 'RUNNING',
  CANCELLED: 'CANCELLED',
  TIMED_OUT: 'TIMED_OUT',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type WorkflowStepStatus = (typeof WorkflowStepStatus)[keyof typeof WorkflowStepStatus]


export const DataType = {
  LONG_STRING: 'LONG_STRING',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  DATE_TIME: 'DATE_TIME',
  TIME: 'TIME',
  FILE: 'FILE',
  IMAGE: 'IMAGE',
  RELATION: 'RELATION',
  OBJECT: 'OBJECT'
} as const

export type DataType = (typeof DataType)[keyof typeof DataType]


export const TriggerType = {
  ACTION: 'ACTION',
  WEBHOOK: 'WEBHOOK',
  AGENT: 'AGENT',
  SUBFLOW: 'SUBFLOW',
  FORM_SUBMISSION: 'FORM_SUBMISSION',
  MANUAL: 'MANUAL',
  SCHEDULE: 'SCHEDULE',
  EVENT: 'EVENT'
} as const

export type TriggerType = (typeof TriggerType)[keyof typeof TriggerType]


export const MigrationStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type MigrationStatus = (typeof MigrationStatus)[keyof typeof MigrationStatus]


export const WorkflowRunTagReferenceType = {
  WORKFLOW_RUN: 'WORKFLOW_RUN'
} as const

export type WorkflowRunTagReferenceType = (typeof WorkflowRunTagReferenceType)[keyof typeof WorkflowRunTagReferenceType]


export const EventListenerEventType = {
  MESSAGE_CREATED: 'MESSAGE_CREATED'
} as const

export type EventListenerEventType = (typeof EventListenerEventType)[keyof typeof EventListenerEventType]


export const HandlePosition = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM'
} as const

export type HandlePosition = (typeof HandlePosition)[keyof typeof HandlePosition]


export const ImportStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
} as const

export type ImportStatus = (typeof ImportStatus)[keyof typeof ImportStatus]


export const ImportMode = {
  ADD_NEW_ONLY: 'ADD_NEW_ONLY',
  ADD_OR_UPDATE: 'ADD_OR_UPDATE',
  UPDATE_EXISTING_ONLY: 'UPDATE_EXISTING_ONLY'
} as const

export type ImportMode = (typeof ImportMode)[keyof typeof ImportMode]


export const ImportRowStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED'
} as const

export type ImportRowStatus = (typeof ImportRowStatus)[keyof typeof ImportRowStatus]


export const ReportDefinitionStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED'
} as const

export type ReportDefinitionStatus = (typeof ReportDefinitionStatus)[keyof typeof ReportDefinitionStatus]


export const CRMMigrationSource = {
  UI: 'UI',
  API: 'API',
  APP_DEPLOY: 'APP_DEPLOY',
  APP_UNINSTALL: 'APP_UNINSTALL',
  CLI: 'CLI',
  SYSTEM: 'SYSTEM',
  APP_PROVISION: 'APP_PROVISION',
  APP_INSTALL: 'APP_INSTALL'
} as const

export type CRMMigrationSource = (typeof CRMMigrationSource)[keyof typeof CRMMigrationSource]


export const CRMMigrationStatus = {
  PENDING: 'PENDING',
  BATCHING: 'BATCHING',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  APPROVED: 'APPROVED',
  EXECUTING: 'EXECUTING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  ROLLED_BACK: 'ROLLED_BACK',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED'
} as const

export type CRMMigrationStatus = (typeof CRMMigrationStatus)[keyof typeof CRMMigrationStatus]


export const CRMOperationType = {
  CREATE_MODEL: 'CREATE_MODEL',
  UPDATE_MODEL: 'UPDATE_MODEL',
  DELETE_MODEL: 'DELETE_MODEL',
  CREATE_FIELD: 'CREATE_FIELD',
  UPDATE_FIELD: 'UPDATE_FIELD',
  DELETE_FIELD: 'DELETE_FIELD',
  UPDATE_FIELD_DEFAULT_VALUE: 'UPDATE_FIELD_DEFAULT_VALUE',
  CREATE_RELATIONSHIP: 'CREATE_RELATIONSHIP',
  UPDATE_RELATIONSHIP: 'UPDATE_RELATIONSHIP',
  DELETE_RELATIONSHIP: 'DELETE_RELATIONSHIP',
  CREATE_FIELD_DEFINITION: 'CREATE_FIELD_DEFINITION',
  UPDATE_FIELD_DEFINITION: 'UPDATE_FIELD_DEFINITION',
  DELETE_FIELD_DEFINITION: 'DELETE_FIELD_DEFINITION',
  CREATE_FIELD_DEFINITION_OPTION: 'CREATE_FIELD_DEFINITION_OPTION',
  UPDATE_FIELD_DEFINITION_OPTION: 'UPDATE_FIELD_DEFINITION_OPTION',
  DELETE_FIELD_DEFINITION_OPTION: 'DELETE_FIELD_DEFINITION_OPTION',
  REORDER_FIELD_DEFINITION_OPTIONS: 'REORDER_FIELD_DEFINITION_OPTIONS'
} as const

export type CRMOperationType = (typeof CRMOperationType)[keyof typeof CRMOperationType]


export const CRMResourceType = {
  MODEL: 'MODEL',
  FIELD: 'FIELD',
  RELATIONSHIP: 'RELATIONSHIP',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  FIELD_DEFINITION_OPTION: 'FIELD_DEFINITION_OPTION'
} as const

export type CRMResourceType = (typeof CRMResourceType)[keyof typeof CRMResourceType]


export const CRMOperationStatus = {
  PENDING: 'PENDING',
  EXECUTING: 'EXECUTING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  ROLLED_BACK: 'ROLLED_BACK',
  SKIPPED: 'SKIPPED'
} as const

export type CRMOperationStatus = (typeof CRMOperationStatus)[keyof typeof CRMOperationStatus]


export const ParticipantKind = {
  CONTACT: 'CONTACT',
  MEMBER: 'MEMBER',
  AGENT: 'AGENT',
  SYSTEM: 'SYSTEM',
  WORKFLOW: 'WORKFLOW',
  BATCH_JOB: 'BATCH_JOB'
} as const

export type ParticipantKind = (typeof ParticipantKind)[keyof typeof ParticipantKind]


export const ThreadStatus = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
  ARCHIVED: 'ARCHIVED'
} as const

export type ThreadStatus = (typeof ThreadStatus)[keyof typeof ThreadStatus]


export const ThreadKind = {
  CONVERSATION: 'CONVERSATION',
  INTERNAL: 'INTERNAL',
  ESCALATION: 'ESCALATION',
  BROADCAST: 'BROADCAST',
  TESTING: 'TESTING'
} as const

export type ThreadKind = (typeof ThreadKind)[keyof typeof ThreadKind]


export const ThreadWorkflowStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED'
} as const

export type ThreadWorkflowStatus = (typeof ThreadWorkflowStatus)[keyof typeof ThreadWorkflowStatus]


export const EventSubscriptionAction = {
  EXECUTE: 'EXECUTE',
  CANCEL: 'CANCEL'
} as const

export type EventSubscriptionAction = (typeof EventSubscriptionAction)[keyof typeof EventSubscriptionAction]


export const ScheduledEventStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  FIRED: 'FIRED',
  CANCELLED: 'CANCELLED'
} as const

export type ScheduledEventStatus = (typeof ScheduledEventStatus)[keyof typeof ScheduledEventStatus]


export const ScheduledMessageStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  CANCELLED: 'CANCELLED'
} as const

export type ScheduledMessageStatus = (typeof ScheduledMessageStatus)[keyof typeof ScheduledMessageStatus]


export const ContactBlockKind = {
  SIGNAL: 'SIGNAL'
} as const

export type ContactBlockKind = (typeof ContactBlockKind)[keyof typeof ContactBlockKind]


export const ThreadBlockKind = {
  MESSAGE: 'MESSAGE',
  REASONING: 'REASONING',
  TOOL_CALL: 'TOOL_CALL',
  WORKFLOW: 'WORKFLOW',
  SUBTHREAD: 'SUBTHREAD',
  THREAD_LINK: 'THREAD_LINK',
  ALERT: 'ALERT',
  CALL: 'CALL',
  ASSOCIATION: 'ASSOCIATION',
  SIGNAL: 'SIGNAL'
} as const

export type ThreadBlockKind = (typeof ThreadBlockKind)[keyof typeof ThreadBlockKind]


export const ThreadBlockStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  WORKFLOW_RUNNING: 'WORKFLOW_RUNNING',
  WORKFLOW_COMPLETED: 'WORKFLOW_COMPLETED',
  WORKFLOW_FAILED: 'WORKFLOW_FAILED',
  WORKFLOW_CANCELLED: 'WORKFLOW_CANCELLED'
} as const

export type ThreadBlockStatus = (typeof ThreadBlockStatus)[keyof typeof ThreadBlockStatus]


export const ParticipantRole = {
  OWNER: 'OWNER',
  PARTICIPANT: 'PARTICIPANT',
  OBSERVER: 'OBSERVER',
  CALL_LEG: 'CALL_LEG'
} as const

export type ParticipantRole = (typeof ParticipantRole)[keyof typeof ParticipantRole]


export const ParticipantVisibility = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  HIDDEN: 'HIDDEN'
} as const

export type ParticipantVisibility = (typeof ParticipantVisibility)[keyof typeof ParticipantVisibility]


export const MessageContentType = {
  TEXT: 'TEXT',
  HTML: 'HTML',
  MARKDOWN: 'MARKDOWN',
  MEDIA: 'MEDIA',
  SYSTEM: 'SYSTEM'
} as const

export type MessageContentType = (typeof MessageContentType)[keyof typeof MessageContentType]


export const ThreadMessageSendStatus = {
  STAGED: 'STAGED',
  SENDING: 'SENDING',
  SENT: 'SENT',
  FAILED: 'FAILED'
} as const

export type ThreadMessageSendStatus = (typeof ThreadMessageSendStatus)[keyof typeof ThreadMessageSendStatus]


export const ChannelBindingSyncStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  ERROR: 'ERROR'
} as const

export type ChannelBindingSyncStatus = (typeof ChannelBindingSyncStatus)[keyof typeof ChannelBindingSyncStatus]


export const ThreadContextKind = {
  INSTANCE: 'INSTANCE',
  THREAD: 'THREAD',
  DOCUMENT: 'DOCUMENT'
} as const

export type ThreadContextKind = (typeof ThreadContextKind)[keyof typeof ThreadContextKind]


export const ThreadContextRole = {
  PRIMARY: 'PRIMARY',
  RELEVANT: 'RELEVANT',
  MENTIONED: 'MENTIONED',
  HISTORICAL: 'HISTORICAL',
  INFERRED: 'INFERRED'
} as const

export type ThreadContextRole = (typeof ThreadContextRole)[keyof typeof ThreadContextRole]


export const ThreadLinkStatus = {
  ACTIVE: 'ACTIVE',
  RESOLVED: 'RESOLVED',
  CANCELLED: 'CANCELLED'
} as const

export type ThreadLinkStatus = (typeof ThreadLinkStatus)[keyof typeof ThreadLinkStatus]


export const ThreadLinkRole = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  MERGED: 'MERGED',
  ESCALATED: 'ESCALATED',
  RELATED: 'RELATED',
  CONSULTATION: 'CONSULTATION'
} as const

export type ThreadLinkRole = (typeof ThreadLinkRole)[keyof typeof ThreadLinkRole]


export const TopicStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  RESOLVED: 'RESOLVED'
} as const

export type TopicStatus = (typeof TopicStatus)[keyof typeof TopicStatus]


export const TagKind = {
  CUSTOM: 'CUSTOM',
  SYSTEM: 'SYSTEM',
  SENTIMENT: 'SENTIMENT',
  ACTION: 'ACTION'
} as const

export type TagKind = (typeof TagKind)[keyof typeof TagKind]


export const DecisionStatus = {
  ACTIVE: 'ACTIVE',
  SUPERSEDED: 'SUPERSEDED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
} as const

export type DecisionStatus = (typeof DecisionStatus)[keyof typeof DecisionStatus]


export const SummaryKind = {
  FULL: 'FULL',
  INCREMENTAL: 'INCREMENTAL',
  TOPIC: 'TOPIC',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY'
} as const

export type SummaryKind = (typeof SummaryKind)[keyof typeof SummaryKind]


export const CallKind = {
  VOICE: 'VOICE',
  VIDEO: 'VIDEO',
  SCREEN_SHARE: 'SCREEN_SHARE'
} as const

export type CallKind = (typeof CallKind)[keyof typeof CallKind]


export const CallDirection = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
} as const

export type CallDirection = (typeof CallDirection)[keyof typeof CallDirection]


export const CallStatus = {
  SCHEDULED: 'SCHEDULED',
  RINGING: 'RINGING',
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  ENDED: 'ENDED',
  MISSED: 'MISSED',
  DECLINED: 'DECLINED',
  FAILED: 'FAILED'
} as const

export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus]


export const CallParticipantStatus = {
  INVITED: 'INVITED',
  RINGING: 'RINGING',
  JOINED: 'JOINED',
  ON_HOLD: 'ON_HOLD',
  LEFT: 'LEFT',
  DECLINED: 'DECLINED',
  MISSED: 'MISSED',
  BUSY: 'BUSY'
} as const

export type CallParticipantStatus = (typeof CallParticipantStatus)[keyof typeof CallParticipantStatus]


export const MentionKind = {
  USER: 'USER',
  CHANNEL: 'CHANNEL',
  ROLE: 'ROLE',
  EVERYONE: 'EVERYONE'
} as const

export type MentionKind = (typeof MentionKind)[keyof typeof MentionKind]
